const list = {
  // =================================================================================================================
  components() {
    // options.items 는 Page.vue 에서 정의되어 있음
    return [
      {
        component: "search-year",
        label: "연도",
        value: "year",
        query: { y: "year" },
        options: {
          useAll: false,
          default: new Date().getFullYear(),
        },
      },
      {
        component: "search-select",
        label: "사업장",
        value: "사업장",
        query: { s0: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "팀명",
        value: "팀명",
        query: { s1: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "공장명",
        value: "공장명",
        query: { s2: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "대분류",
        value: "대분류",
        query: { s3: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "중분류",
        value: "중분류",
        query: { s4: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "소분류",
        value: "소분류",
        query: { s5: "select" },
        options: {
          default: "전체",
          items: [],
          immediate: true,
        },
      },
      {
        component: "search-select",
        label: "위험성평가 실시 여부",
        value: "실시여부",
        query: { risk: "select" },
        options: {
          default: "",
          items: [
            { text: "전체", value: "" },
            { text: "개정필요", value: "개정필요" },
            { text: "실시완료", value: "실시완료" },
            { text: "결재중", value: "결재중" },
            { text: "미실시", value: "미실시" },
          ],
          immediate: true,
        },
      },
    ];
  },
  getConditions: () => {
    const conditions = [];
    // 모든 필터는 클라이언트에서 처리하므로 서버 조건은 빈 배열
    // 사업장, 팀명, 공장명, 대분류, 중분류, 소분류, 연도, 실시여부 모두 제거
    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.사업장.field_name",
      },
      {
        name: "팀명",
        key: "body.팀명",
      },
      {
        name: "공장명",
        key: "body.공장명",
      },
      {
        name: "분류명",
        key: ["body.대분류", "body.중분류", "body.소분류"],
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContent(value).점검일; // 점검일
        case 2:
          return func.getContent(value).stdInfo.department; // 소속명
        case 3:
          return func.getContent(value).stdInfo.section; // 부서명
        case 4:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 5:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: () => {},
  getSearchKeyword: () => {},
};
export default list;
